import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';

export default {
  load() {
    const url = formUrl('/api/v1/admin/messages');

    return FetchHelpers.get(url);
  },
};
